import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IApplicationComponentResolver } from '../interfaces/iapplication-component-resolver.interface';

// TODO: deprecate and remove the ApplicationComponentResolverService in favor of the component loader
/**
 * @deprecated This service will soon be deprecated. Please use the ComponentLoaderService instead.
 */
@Injectable()
export class ApplicationComponentResolverService {
	public resolver$ = new BehaviorSubject<IApplicationComponentResolver>(null);
	public remover$ = new BehaviorSubject<IApplicationComponentResolver>(null);

	resolve(resolver: IApplicationComponentResolver): void {
		this.resolver$.next(resolver);
	}

	remove(resolver: IApplicationComponentResolver): void {
		this.remover$.next(resolver);
	}
}
